import React, { useState, useEffect, useRef } from "react";
import {
  IconArrowDropDown,
  IconArrowDropUp,
  Input,
  Menu,
  MenuListItem
} from 'cdk-radial';

const attributeKeyToLabel = {
  env: 'Environment',
  ver: 'Version',
  exs: 'Examples'
};

export const AttributeSelection = ({attributeKey, items, onItemSelection, dataTestId, defaultOption, id, value}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState({
    label: '',
    value: ''
  });

  useEffect(() => {
    if (Array.isArray(items) && items.length > 0) {
      const locOptions = [];
      items.forEach((item, idx) => {
        locOptions.push({
          label: item,
          value: idx
        });
      });
      setOptions(locOptions);
    }
  }, [items])

  useEffect(() => {
    if (defaultOption && options.length && !value) {
      const selectedDefaultOption = options.find(o => o.label === defaultOption);
      if (selectedDefaultOption) {
        setSelectedOption(selectedDefaultOption);
      }
    }
  }, [defaultOption, options]);

  useEffect(() => {
    if (value && options.length) {
      const selectedValueOption = options.find(o => o.label === value);
      if (selectedValueOption) {
        setSelectedOption(selectedValueOption);
      }
    }
  }, [value, options]);

  const targetRef = useRef();
  const dimensionRef = useRef();
  const menuContainerRef = useRef();

  const handleOpen = _ => {
    setIsOpen(true);
  };

  const handleClose = _ => {
    setIsOpen(false);
  };

  const handleSelect = option => {
    setSelectedOption(option);
    setIsOpen(false);
    onItemSelection(attributeKey, option);
  };

  useEffect(() => {
    const setIsOpenFromMenu = event => {
      if (event.detail.ref === menuContainerRef)
        setIsOpen(event.detail.openMenu);
    };
    document.addEventListener('customMenuOpenEvent', setIsOpenFromMenu);
    return () =>
      document.removeEventListener('customMenuOpenEvent', setIsOpenFromMenu);
  }, []);

  return (
    <div className="api-dir-pkg_response-selector-wrapper" data-testid={dataTestId}>
      <div
        data-testid={`single-select-dropdown-${attributeKey}`}
        className="api-dir-pkg_attribute-selector-wrapper"
      >
        <Input
          dataTestId={`menu-input-${attributeKey}`}
          helperText=""
          icon={isOpen ? <IconArrowDropUp /> : <IconArrowDropDown />}
          id={id ? id : `single-select-dropdown-${attributeKey}`}
          label={attributeKeyToLabel[attributeKey]}
          labelRef={dimensionRef}
          name={id ? id : `single-select-dropdown-${attributeKey}`}
          onChange={() => {}}
          placeholder="Select"
          ref={targetRef}
          value={selectedOption.label}
          style={{ caretColor: 'transparent' }}
        />
      </div>
      <Menu
        dataTestId="menu-container"
        dimensionRef={dimensionRef}
        isOpen={isOpen}
        labelRef={targetRef}
        onClose={handleClose}
        onOpen={handleOpen}
        isAuto={false}
        ref={menuContainerRef}
        style={{ maxWidth: 'fit-content' }}
      >
        {options.map((option, ind) => (
          <div className="api-dir-pkg_attribute-selector-width">
            <MenuListItem
              dataTestId={`menu-item-${ind}`}
              isDisabled={option.disabled}
              isSelected={option.value === selectedOption.value}
              key={ind}
              onClick={() => handleSelect(option)}
              hideSelectedItemCheckmark={false}
            >
              {option.label}
            </MenuListItem>
          </div>
        ))}
      </Menu>
    </div>
  );


}
